export default __webpack_public_path__ + "static/media/8.1e9ecdc7.jpg";